import { styles } from '@material-ui/core/InputBase/InputBase';

export const inputStyles = {
    root: {
        height: 19,
    },
};

export const inputBraintreeStyle = (theme) => {
    const style = styles(theme);
    return {
        input: {
            'font-family': style.root.fontFamily,
            'font-size': style.root.fontSize,
            color: style.root.color,
            'line-height': style.root.lineHeight,
        },
    };
};
